import { Button } from '@mui/material';
import React from 'react'
import styled from 'styled-components';
import { auth, provider } from '../firebase';

function Login() {
    const signin = e => {
        e.preventDefault();
        auth.signInWithPopup(provider).catch((error)=>alert(error.message));
    };
  return (
   <LoginContainer>
       <LoginInnerConaitner>
            <img src='https://a.slack-edge.com/80588/marketing/img/icons/icon_slack_hash_colored.png' alt=''/>
      <h1>Sign in to my React Hub</h1>
      <p>imed.slack.com</p>
      <Button  onClick={signin}>
          Sign in with Google
      </Button>
       </LoginInnerConaitner>
   </LoginContainer> 
  )
}

export default Login;
const LoginInnerConaitner = styled.div`
padding: 100px;
text-align: center;
background-color: white;
border-radius:7px;
box-shadow: 0 1px 3px rgba(0,0,0.12), 0 1px 2px rgba(0,0,0.24);
>img{
    object-fit: contain;
    height: 100px;
    margin-bottom:40px;
}
>button{
    margin-top: 50px;
    text-transform: inherit !important;
    background-color: #0aBd48 !important;
    color: white;
}
`;

const LoginContainer = styled.div`
background-color: #f8f8f8;
height: 100vh;
display: grid;
place-items: center;
`;